// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { router } from './router/router.js'

//vuex状态管理
import store from './store/index'


import './assets/css/base.css'
import './assets/css/mixin.scss'

//自动转换REM
import 'lib-flexible/flexible.js'

// 组件的使用
import components from './components'
Vue.use(components)

//全局方法
import gob from './utils'
Vue.prototype.gob = gob

Vue.config.productionTip = false

/* eslint-disable no-new */
const app= new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js